import { useParams } from 'react-router-dom';
import { ContentCourseDetail } from './ContentCourseDetail';


export function ContentCourseDetailPage() {

  const {courseId} = useParams();
  

  return (
    <ContentCourseDetail courseId={courseId || ''} />
  );
} 